import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import cloneDeep from 'lodash/cloneDeep';

import {
  IEvl0105MState,
  IUserInfoState,
  IEvaluatorInfoState,
  IPerformanceRowState,
  ICompetencyRowState,
  ITaskRowState,
  IRowDataState,
  IInquiryCndsState,
} from '../../models/evl/evl0105m_model';

const initialState: IEvl0105MState = {
    userInfo: {
    empNo: '',
    userNm: '',
    position: '',
    role: '',
    department: '',
    team: '',
    jobGrCd: '',
    empPostCd:'',
  },
  evaluatorInfo: {
    eval1EmpNo: '',
    eval1DeptCd: '',
    eval1PosClsCd: '',
    eval2EmpNo: '',
    eval2DeptCd: '',
    eval2PosClsCd: '',
  },
  itemDescriptions: {},
  performanceData: [],
  competencyData: [],
  taskData: [],
  rowData: [],
  inquiryCnds: {},
  error: null,
  pageSize: 20,
  current: 0,
  role: "none",           
};

export interface IPropsEvl0106M {
    empNo          : string;    // 로그인 사번
    hrMapId        : string;    // 맵아이디
    evlYear        : string;    // 년도
}

export const evl0105m_Slice = createSlice({
  name: 'evl0105m_Slice',
  initialState,
  reducers: {
    initState: (state) => {
      const newState = cloneDeep(initialState);
      return { ...newState };
    },
    setUserInfo: (state, action: PayloadAction<IUserInfoState>) => {
      state.userInfo = action.payload;
    },
    setEvaluatorInfo: (state, action: PayloadAction<IEvaluatorInfoState>) => {
      state.evaluatorInfo = action.payload;
    },
    setPerformanceData: (state, action: PayloadAction<IPerformanceRowState[]>) => {
      state.performanceData = action.payload;
    },
    setCompetencyData: (state, action: PayloadAction<ICompetencyRowState[]>) => {
      state.competencyData = action.payload;
    },
    setTaskData: (state, action: PayloadAction<ITaskRowState[]>) => {
      state.taskData = action.payload;
    },
    setRowData: (state, action: PayloadAction<IRowDataState[]>) => {
      state.rowData = action.payload;
    },
    setInquiryCnds: (state, action: PayloadAction<IInquiryCndsState>) => {
      state.inquiryCnds = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload;
    },
    setCurrent: (state, action: PayloadAction<number>) => {
      state.current = action.payload;
    },
    setRole(state,action: PayloadAction<"self" | "first" | "second" | "none"> ) {
      state.role = action.payload;
    },
    
  },
});

export default evl0105m_Slice.reducer;
export const Evl0105mAction = evl0105m_Slice.actions;
export const Evl0105mReducer = evl0105m_Slice.reducer;